import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { LinkSlackChannel } from 'domain/usecases';

import { RemoteLinkSlackChannel } from 'data/usecases/slack';

export const makeLinkSlackChannels = (): LinkSlackChannel => {
  return new RemoteLinkSlackChannel(makeApiUrl('/slack/location/channels'), makeAuthorizeHttpClientDecorator());
};
